const PATIENT_HISTORY_FIELD_LABELS: Record<string, string> = {
  additional_information: 'Zusatz',
  affected_organ: 'Befallene Organe',
  arrival: 'Einreisedatum',
  asylum_number: 'N-Nummer',
  birth_date: 'Geburtsdatum',
  case_concluded: 'Fall abgeschlossen',
  case_concluded_at: 'Abschlussdatum',
  case_number: 'Fallnummer',
  case_number_canton: 'Fallnummer Kanton',
  case_number_id: 'Fallnummer ID',
  case_number_year: 'Fallnummer Jahr',
  case_type: 'Fallart',
  city: 'Ort',
  clinical_detection_method: 'Nachweismethode',
  clinical_test_material: 'Material',
  complex_case_status: 'Komplexer Fall',
  condition_interval: 'Intervall',
  contact_patient_exposure: 'Kontaktdauer (h)',
  contact_patient_last_contact: 'Letzter Kontakt',
  contact_patient_relationship_status: 'Beziehung zum IP',
  contact_tracing: 'Umgebungsuntersuchung',
  contact_tracing_type: 'Art der Umgebungs untersuchung',
  copy_address: 'Adresse',
  copy_address_type: 'Adresstyp',
  copy_canton: 'Kanton',
  copy_city: 'Ort',
  copy_contact_email: 'Kontakt E-Mail-Adresse',
  copy_contact_first_name: 'Kontakt Vorname',
  copy_contact_function: 'Kontakt Funktion',
  copy_contact_last_name: 'Kontakt Nachname',
  copy_contact_phone: 'Kontakt Telefon',
  copy_email: 'E-Mail-Adresse',
  copy_homepage: 'Homepage',
  copy_organization: 'Institution',
  copy_phone: 'Telefon',
  copy_zip: 'PLZ',
  copy_zusatz: 'Zusatz',
  date: 'Datum',
  direct_payer: 'Selbstzahler',
  directly_observed_therapy_needed: 'DOT notwendig',
  email: 'E-Mail-Adresse',
  end: 'Therapie Ende',
  entry_date: 'Eintrittsdatum',
  enzyme: 'Enzym',
  external_id: 'Externe ID',
  finished: 'Therapie abgeschlossen',
  first_name: 'Vorname',
  gender: 'Geschlecht',
  is_selected: 'Ausgewählt',
  lab_detection_method: 'Nachweismethode',
  lab_order_result_type: 'Resultat-Typ',
  lab_order_test_type: 'Test-Typ',
  lab_test_material: 'Test-Typ',
  languages: 'Sprachen',
  last_name: 'Nachname',
  living_status: 'Lebensstatus',
  mobile_phone_number: 'Telefon Nr. Mobil',
  mutation_status: 'Mutation',
  name: 'Name',
  nationality_country_code: 'Nationalität',
  note: 'Bemerkungen',
  notes: 'Bemerkungen',
  origin_country_code: 'Herkunftsland',
  other_material: 'Material',
  other_organ_name: 'Organ',
  phone: 'Telefon',
  phone_number: 'Telefon',
  position: 'Funktion',
  postal_code: 'PLZ',
  private_phone_number: 'Telefon Nr. Privat',
  referenceValue: 'Referenzwert',
  relation_type: 'Beziehung',
  residency_permit: 'FREPO-Status',
  residency_type: 'Wohnhaft',
  resistance: 'Resistenz',
  resistance_name: 'Resistenz',
  result: 'Resultat',
  result_interpretation: 'Interpretation',
  result_note: 'Bemerkung',
  salutation: 'Anrede',
  sampling_date: 'Meldedatum',
  sampling_time: 'Zeit',
  sampling_time_of_day: 'Tageszeit',
  species: 'Spezies',
  start_phase_1: 'Therapie Start',
  start_phase_2: 'Start Phase 2',
  state: 'Kanton',
  street: 'Strasse',
  supplement_date: 'Ergänzungsmeldung Datum',
  test_result: 'Resultat',
  therapy_compliance: 'Compliance',
  therapy_condition: 'Befinden',
  therapy_result: 'Resultat',
  tracing_assessment_result_note: 'Bemerkungen',
  tracing_assessment_status: 'Status',
  tracing_incubation_period_end: 'Bis',
  tuberculosis_fund: 'TB Fonds',
  unit: 'Einheit',
  work_phone_number: 'Telefon Nr. Geschäft',
  zemis_number: 'ZEMIS-Nummer',
};

function formatUnknownFieldName(fieldName: string) {
  const formatted = fieldName
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .trim();

  return formatted ? formatted.charAt(0).toUpperCase() + formatted.slice(1) : fieldName;
}

export function getPatientHistoryFieldLabel(fieldName: string | null | undefined) {
  const trimmedFieldName = fieldName?.trim() ?? '';

  if (!trimmedFieldName) {
    return 'Feld';
  }

  return (
    PATIENT_HISTORY_FIELD_LABELS[trimmedFieldName] ??
    PATIENT_HISTORY_FIELD_LABELS[trimmedFieldName.toLowerCase()] ??
    formatUnknownFieldName(trimmedFieldName)
  );
}
